import { useEffect, useState } from "react";

/**
 * Returns false during SSR and the initial client render, then true after
 * mount. Use to gate UI that depends on browser-only state (viewport,
 * stored language, localStorage flags) and would otherwise produce SSR↔
 * client hydration mismatches. Keep usage narrow — do not gate entire
 * routes.
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
